import { render, staticRenderFns } from "./addSon.vue?vue&type=template&id=a52c547c&scoped=true&"
import script from "./addSon.vue?vue&type=script&lang=js&"
export * from "./addSon.vue?vue&type=script&lang=js&"
import style0 from "./addSon.vue?vue&type=style&index=0&id=a52c547c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52c547c",
  null
  
)

export default component.exports